exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 600px) {\n  .mat-sidenav,\n  .mat-sidenav.md-locked-open,\n  .mat-sidenav.md-locked-open-add-active {\n    width: 100% !important;\n    min-width: 254px !important;\n    max-width: 100% !important; } }\n\n.sidenav-container {\n  padding: 10px;\n  min-width: 100px;\n  z-index: 100; }\n\n.header-toolbar {\n  top: 0;\n  left: 0;\n  z-index: 2;\n  width: 100% !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/muth/Documents/privat/angular/guidr/src/app/components/app/app.component.scss
// module id = ../../../../../src/app/components/app/app.component.scss
// module chunks = main